import {
  all, takeLatest, takeEvery, put,
} from 'redux-saga/effects';

import * as errorSagas from './error';

import { actions as errorActions, types as errorTypes } from '../reducers/error';
import { types as academiesTypes } from '../reducers/academies';
import { types as materiasTypes } from '../reducers/materias';
import { types as usersTypes } from '../reducers/users';
import { types as usuariosTypes } from '../reducers/usuarios';
import { types as examenesTypes } from '../reducers/examenes';
import { types as preguntasTypes } from '../reducers/preguntas';
import { types as forosTypes } from '../reducers/foros';
import { handlingCodes, normalizeHttpErrors } from './normalizers/errorNormalizer';
import { URL } from '../utils/urlLibrary';
import { hasStoredAuthSession, isExplicitLogoutFlowActive } from '../utils/logoutFlow';


import * as academiesSagas from './academies';
import * as materiasSagas from './materias';
import * as usersSagas from './users';
import * as usuariosSagas from './usuarios';
import * as examenesSagas from './examenes';
import * as preguntasSagas from './preguntas';
import * as forosSagas from './foros';
  
export default function* rootSaga() {
  yield all([
    // Academies
    takeLatest(academiesTypes.GET_PLATAFORMAS_BEGINS, academiesSagas.getPlataformas),
    takeLatest(academiesTypes.GET_ACADEMIES_BEGINS, academiesSagas.getAcademies),
    takeLatest(academiesTypes.POST_ACADEMIES_BEGINS, academiesSagas.postAcademies),
    takeLatest(academiesTypes.EDIT_ACADEMIES_BEGINS, academiesSagas.editAcademies),
    takeLatest(academiesTypes.DELETE_ACADEMIES_BEGINS, academiesSagas.deleteAcademies),
    takeLatest(academiesTypes.GET_ACADEMY_DELETE_IMPACT_BEGINS, academiesSagas.getAcademyDeleteImpact),
    // Usuarios
    takeLatest(usuariosTypes.GET_ROLES_BEGINS, usuariosSagas.getRoles),
    takeLatest(usuariosTypes.GET_USUARIOS_BEGINS, usuariosSagas.getUsuarios),
    takeLatest(usuariosTypes.POST_USUARIOS_BEGINS, usuariosSagas.postUsuarios),
    takeLatest(usuariosTypes.EDIT_USUARIOS_BEGINS, usuariosSagas.editUsuarios),
    takeLatest(usuariosTypes.DELETE_USUARIOS_BEGINS, usuariosSagas.deleteUsuarios),
    takeLatest(usuariosTypes.DELETE_BATCH_USUARIOS_BEGINS, usuariosSagas.deleteUsuariosBatch),
    // Materias
    takeLatest(materiasTypes.GET_MATERIAS_BEGINS, materiasSagas.getMaterias),
    takeLatest(materiasTypes.POST_MATERIAS_BEGINS, materiasSagas.postMaterias),
    takeLatest(materiasTypes.EDIT_MATERIAS_BEGINS, materiasSagas.editMaterias),
    takeLatest(materiasTypes.DELETE_MATERIAS_BEGINS, materiasSagas.deleteMaterias),
    takeLatest(materiasTypes.GET_MATERIAS_DISPONIBLES_BEGINS, materiasSagas.getMateriasDisponibles),
    // Login
    takeLatest(usersTypes.MAKE_LOGIN_BEGINS, usersSagas.makeLogin),
    // Logout
    takeLatest(usersTypes.MAKE_LOGOUT_BEGINS, usersSagas.makeLogout),
    // Authenticated
    takeLatest(usersTypes.GET_AUTHENTICATED_BEGINS, usersSagas.getAuthenticated),
    takeLatest(usersTypes.CHANGE_PASSWORD_BEGINS, usersSagas.changePassword),
    // Error
    takeLatest(errorTypes.SHOW_ERROR, errorSagas.goErrorPage),
    // Examenes
    takeLatest(examenesTypes.GET_EXAMENES_BEGINS, examenesSagas.getExamenes),
    takeLatest(examenesTypes.POST_EXAMENES_BEGINS, examenesSagas.postExamenes),
    takeLatest(examenesTypes.EDIT_EXAMENES_BEGINS, examenesSagas.editExamenes),
    takeLatest(examenesTypes.DELETE_EXAMENES_BEGINS, examenesSagas.deleteExamenes),
    takeLatest(examenesTypes.UPDATE_EXAMEN_BEGIN, examenesSagas.updateExamen),
    takeLatest(examenesTypes.GET_VISIBILIDAD_EXTERNA_BEGINS, examenesSagas.getVisibilidadExterna),
    takeLatest(examenesTypes.BATCH_GET_VISIBILIDAD_EXTERNA_BEGINS, examenesSagas.batchGetVisibilidadExterna),
    takeLatest(examenesTypes.UPDATE_VISIBILIDAD_EXTERNA_BEGIN, examenesSagas.updateVisibilidadExterna),
    takeLatest(examenesTypes.BATCH_UPDATE_VISIBILIDAD_EXTERNA_BEGIN, examenesSagas.batchUpdateVisibilidadExterna),
    takeLatest(examenesTypes.POST_SUBIR_EXAMEN_BEGINS, examenesSagas.postSubirExamen),
    takeLatest(examenesTypes.POST_SUBIR_EXAMENES_BATCH_BEGINS, examenesSagas.postSubirExamenesBatch),
    takeLatest(examenesTypes.GET_EXAMENES_ACADEMIA_USUARIO_BEGINS, examenesSagas.getExamenesAcademiaUsuario),
    takeLatest(examenesTypes.CHECK_EXAMEN_GUARDADO_BEGINS, examenesSagas.checkExamenGuardado),
    takeLatest(examenesTypes.GET_EXAMEN_GUARDADO_BEGINS, examenesSagas.getExamenGuardado),
    takeLatest(examenesTypes.POST_GUARDAR_EXAMEN_BEGINS, examenesSagas.postGuardarExamen),
    takeLatest(examenesTypes.ELIMINAR_EXAMEN_GUARDADO_BEGINS, examenesSagas.eliminarExamenGuardado),
    // Preguntas
    takeLatest(preguntasTypes.GET_PREGUNTAS_BEGINS, preguntasSagas.getPreguntas),
    takeLatest(preguntasTypes.POST_PREGUNTAS_BEGINS, preguntasSagas.postPreguntas),
    takeLatest(preguntasTypes.EDIT_PREGUNTAS_BEGINS, preguntasSagas.editPreguntas),
    takeLatest(preguntasTypes.DELETE_PREGUNTAS_BEGINS, preguntasSagas.deletePreguntas),
    takeLatest(preguntasTypes.GET_PREGUNTA_BEGINS, preguntasSagas.getPregunta),
    takeLatest(preguntasTypes.GET_PREGUNTAS_EXAMENES_ACADEMIA_BEGINS, preguntasSagas.getPreguntasExamenesAcademia),
    takeLatest(preguntasTypes.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_BEGINS, preguntasSagas.getPreguntasExamenesAcademiaCrud),
    takeLatest(preguntasTypes.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_BEGINS, preguntasSagas.postExportBuscadorPreguntasPdf),
    takeLatest(preguntasTypes.POST_PREGUNTA_CON_OPCIONES_BEGINS, preguntasSagas.postPreguntaConOpciones),
    takeLatest(preguntasTypes.EDIT_PREGUNTA_CON_OPCIONES_BEGINS, preguntasSagas.editPreguntaConOpciones),
    takeLatest(preguntasTypes.GET_RECUENTO_MATERIAS_BEGINS, preguntasSagas.getRecuentoMaterias),
    takeLatest(preguntasTypes.GET_CASOS_CLINICOS_EXAMEN_BEGINS, preguntasSagas.getCasosClinicosExamen),
    takeLatest(preguntasTypes.POST_CASO_CLINICO_BEGINS, preguntasSagas.postCasoClinico),
    takeLatest(preguntasTypes.PUT_CASO_CLINICO_BEGINS, preguntasSagas.putCasoClinico),
    takeLatest(preguntasTypes.DELETE_CASO_CLINICO_BEGINS, preguntasSagas.deleteCasoClinico),
    takeLatest(preguntasTypes.SAVE_CASOS_CLINICOS_EXAMEN_BEGINS, preguntasSagas.saveCasosClinicosExamen),
    takeLatest(preguntasTypes.UPLOAD_CASOS_CLINICOS_EXCEL_BEGINS, preguntasSagas.uploadCasosClinicosExcel),
    takeLatest(preguntasTypes.POST_PREGUNTAS_EXAMEN_BEGINS, preguntasSagas.postPreguntasExamen),
    takeLatest(preguntasTypes.POST_PREGUNTAS_FINALIZAR_EXAMEN_BEGINS, preguntasSagas.postPreguntasFinalizarExamen),
    takeLatest(preguntasTypes.GET_MATERIAS_ERRONEAS_BEGINS, preguntasSagas.getMateriasErroneas),
    takeLatest(preguntasTypes.DELETE_ALL_PREGUNTAS_ERRONEAS_BEGIN, preguntasSagas.deleteAllPreguntasErroneas),
    // Foros
    takeLatest(forosTypes.GET_FOROS_MATERIAS_BEGINS, forosSagas.getMaterias),
    takeLatest(forosTypes.GET_FOROS_HILOS_BEGINS, forosSagas.getHilosMateria),
    takeLatest(forosTypes.GET_FORO_HILO_DETALLE_BEGINS, forosSagas.getHiloDetalle),
    takeLatest(forosTypes.POST_FORO_HILO_BEGINS, forosSagas.postHilo),
    takeLatest(forosTypes.POST_FORO_RESPUESTA_BEGINS, forosSagas.postRespuesta),
    takeLatest(forosTypes.DELETE_FORO_HILO_BEGINS, forosSagas.deleteHilo),
    takeLatest(forosTypes.DELETE_FORO_RESPUESTA_BEGINS, forosSagas.deleteRespuesta),
  ])
}

export function* handleSagaError(currentSagaName, error, reducerFailureAction) {
  const errorNormalized = normalizeHttpErrors(currentSagaName, error);
  const { handlingCode } = errorNormalized;
  switch (handlingCode) {
    
    case handlingCodes.LOGIN:
      // Si el usuario ha cerrado sesión manualmente, o ya no quedan credenciales locales,
      // cualquier 401/498 tardío debe volver al login y no mostrar sesión expirada.
      if (isExplicitLogoutFlowActive() || !hasStoredAuthSession() || error.status === 498) {
        // Limpia Redux
        yield put({ type: 'RESET_USER' });
        window.location.href = `#${URL.home.hash}`;
        break;
      }else{
        // HACER LOGIN
      window.location.href = `#${URL.sessionExpired.hash}`;
      break;
      }
      
    default:
      yield put(errorActions.showError({ ...errorNormalized }));
      break;
  }

  if (reducerFailureAction) {
    yield put(reducerFailureAction);
  }
}

export const sagaNames = {
  GET_PLATAFORMAS: 'GET_PLATAFORMAS',
  GET_ACADEMIES: 'GET_ACADEMIES',
  POST_ACADEMIES: 'POST_ACADEMIES',
  EDIT_ACADEMIES: 'EDIT_ACADEMIES',
  DELETE_ACADEMIES: 'DELETE_ACADEMIES',
  GET_ACADEMY_DELETE_IMPACT: 'GET_ACADEMY_DELETE_IMPACT',
  GET_MATERIAS: 'GET_MATERIAS',
  POST_MATERIAS: 'POST_MATERIAS',
  EDIT_MATERIAS: 'EDIT_MATERIAS',
  DELETE_MATERIAS: 'DELETE_MATERIAS',
  GET_MATERIAS_DISPONIBLES: 'GET_MATERIAS_DISPONIBLES',
  GET_ROLES: 'GET_ROLES',
  GET_USUARIOS: 'GET_USUARIOS',
  POST_USUARIOS: 'POST_USUARIOS',
  EDIT_USUARIOS: 'EDIT_USUARIOS',
  DELETE_USUARIOS: 'DELETE_USUARIOS',
  DELETE_BATCH_USUARIOS: 'DELETE_BATCH_USUARIOS',
  MAKE_LOGIN: 'MAKE_LOGIN',
  MAKE_LOGOUT: 'MAKE_LOGOUT',
  GET_AUTHENTICATED: 'GET_AUTHENTICATED',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  GET_EXAMENES: 'GET_EXAMENES',
  POST_EXAMENES: 'POST_EXAMENES',
  EDIT_EXAMENES: 'EDIT_EXAMENES',
  DELETE_EXAMENES: 'DELETE_EXAMENES',
  UPDATE_EXAMEN: 'UPDATE_EXAMEN',
  GET_VISIBILIDAD_EXTERNA: 'GET_VISIBILIDAD_EXTERNA',
  UPDATE_VISIBILIDAD_EXTERNA: 'UPDATE_VISIBILIDAD_EXTERNA',
  POST_SUBIR_EXAMEN: 'POST_SUBIR_EXAMEN',
  POST_SUBIR_EXAMENES_BATCH: 'POST_SUBIR_EXAMENES_BATCH',
  GET_EXAMENES_ACADEMIA_USUARIO: 'GET_EXAMENES_ACADEMIA_USUARIO',
  CHECK_EXAMEN_GUARDADO: 'CHECK_EXAMEN_GUARDADO',
  GET_EXAMEN_GUARDADO: ' GET_EXAMEN_GUARDADO',
  POST_GUARDAR_EXAMEN: 'POST_GUARDAR_EXAMEN',
  ELIMINAR_EXAMEN_GUARDADO: 'ELIMINAR_EXAMEN_GUARDADO',
  GET_PREGUNTAS: 'GET_PREGUNTAS',
  POST_PREGUNTAS: 'POST_PREGUNTAS',
  EDIT_PREGUNTAS: 'EDIT_PREGUNTAS',
  DELETE_PREGUNTAS: 'DELETE_PREGUNTAS',
  GET_PREGUNTA: 'GET_PREGUNTA',
  GET_PREGUNTAS_EXAMENES_ACADEMIA: 'GET_PREGUNTAS_EXAMENES_ACADEMIA',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD: 'GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD',
  POST_EXPORT_BUSCADOR_PREGUNTAS_PDF: 'POST_EXPORT_BUSCADOR_PREGUNTAS_PDF',
  POST_PREGUNTA_CON_OPCIONES: 'POST_PREGUNTA_CON_OPCIONES',
  EDIT_PREGUNTA_CON_OPCIONES: 'EDIT_PREGUNTA_CON_OPCIONES',
  GET_RECUENTO_MATERIAS: 'GET_RECUENTO_MATERIAS',
  GET_CASOS_CLINICOS_EXAMEN: 'GET_CASOS_CLINICOS_EXAMEN',
  POST_CASO_CLINICO: 'POST_CASO_CLINICO',
  PUT_CASO_CLINICO: 'PUT_CASO_CLINICO',
  DELETE_CASO_CLINICO: 'DELETE_CASO_CLINICO',
  SAVE_CASOS_CLINICOS_EXAMEN: 'SAVE_CASOS_CLINICOS_EXAMEN',
  UPLOAD_CASOS_CLINICOS_EXCEL: 'UPLOAD_CASOS_CLINICOS_EXCEL',
  POST_PREGUNTAS_EXAMEN: 'POST_PREGUNTAS_EXAMEN',
  POST_PREGUNTAS_FINALIZAR_EXAMEN: 'POST_PREGUNTAS_FINALIZAR_EXAMEN',
  GET_MATERIAS_ERRONEAS: 'GET_MATERIAS_ERRONEAS',
  DELETE_ALL_PREGUNTAS_ERRONEAS: 'DELETE_ALL_PREGUNTAS_ERRONEAS',
  GET_FOROS_MATERIAS: 'GET_FOROS_MATERIAS',
  GET_FOROS_HILOS: 'GET_FOROS_HILOS',
  GET_FORO_HILO_DETALLE: 'GET_FORO_HILO_DETALLE',
  POST_FORO_HILO: 'POST_FORO_HILO',
  POST_FORO_RESPUESTA: 'POST_FORO_RESPUESTA',
  DELETE_FORO_HILO: 'DELETE_FORO_HILO',
  DELETE_FORO_RESPUESTA: 'DELETE_FORO_RESPUESTA',
};
